/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Link,
} from '@react-pdf/renderer';

import { InvoiceDetails } from 'renderer/features/payments-page/schemas/transaction.transformer';
import { formatCurrency } from 'renderer/shared/formatters/formatters';
import Logo from './logo.png';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 30,
  },

  logo: {
    width: 124,
    height: 77,
    marginBottom: 10,
  },
  invoiceTitle: {
    fontSize: 20,
    textAlign: 'right',
    fontWeight: 'bold',
    marginBottom: 5,
  },
  invoiceDate: {
    fontSize: 10,
    textAlign: 'right',
    marginBottom: 20,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },

  addressContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  addressHeader: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  addressBlock: {
    width: '45%',
  },
  addressContent: {
    fontSize: 10,
    marginBottom: 3,
  },

  detailsTable: {
    marginBottom: 20,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#CCCCCC',
    borderBottomColor: '#000',
    borderBottomWidth: 1,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomColor: '#000',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
  },
  tableCellHeader: {
    flex: 1,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
  },
  tableCell: {
    flex: 1,
    fontSize: 10,
    textAlign: 'center',
    padding: 5,
  },

  footer: {
    marginTop: 20,
    fontSize: 10,
    textAlign: 'center',
  },
  bold: {
    marginTop: 20,
    fontWeight: 'bold',
    fontSize: 10,
    textAlign: 'left',
  },
  totalContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 20,
  },
  totalLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: 10,
  },
  totalValue: {
    fontSize: 10,
    fontWeight: 'bold',
  },
});

const productTableStyles = StyleSheet.create({
  table: {
    marginTop: 10,
    marginBottom: 20,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  tableHeader: {
    flexDirection: 'row',
    // backgroundColor: '#EEEEEE',
    backgroundColor: 'CCCCCC',
    alignItems: 'center',
    borderBottomColor: '#000',
    borderBottomWidth: 1,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: '#000',
    borderBottomWidth: 1,
  },
  tableColHeader: {
    flex: 1,
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
    backgroundColor: '#CCCCCC',
  },
  tableCol: {
    flex: 1,
    fontSize: 10,
    textAlign: 'center',
    padding: 5,
  },
  productDescription: {
    fontSize: 10,
    textAlign: 'left',
    padding: 5,
    flex: 2,
    textWrap: 'wrap',
  },
});

const paymentStyles = StyleSheet.create({
  box: {
    marginTop: 5,
    marginBottom: 5,
    width: '45%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  header: {
    backgroundColor: '#EEEEEE',
    fontWeight: 'bold',
    padding: 5,
    fontSize: 8,
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
  },
  'row:last-child': {
    borderBottom: 0,
  },
  content: {
    padding: 5,
    fontSize: 8,
    flex: 1,
    textAlign: 'right',
  },
});

const summaryStyles = StyleSheet.create({
  box: {
    marginTop: 5,
    marginBottom: 5,
    width: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    padding: 5,
    fontSize: 8,
    flex: 3,
    textAlign: 'left',
    backgroundColor: '#EEEEEE',
  },
  value: {
    padding: 5,
    fontSize: 8,
    flex: 2,
    textAlign: 'right',
    backgroundColor: '#FFFFFF',
  },
});

const ExportPDFView = ({ transaction }: { transaction: InvoiceDetails }) => {
  // Filter serials without 'PWRP' prefix
  const nonPowerSearchSerials = transaction.serialKey
    .split(',')
    .filter((serial: string) => !serial.startsWith('PWRP'));

  // Filter serials with 'PWRP' prefix
  const powerSearchSerials = transaction.serialKey
    .split(',')
    .filter((serial: string) => serial.startsWith('PWRP'));

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.headerContainer}>
          <Image style={styles.logo} src={Logo} />
          <View>
            <Text style={styles.invoiceTitle}>INVOICE</Text>
          </View>
        </View>

        <View style={styles.addressContainer}>
          {transaction.customer.deliveryAddress && (
            <View style={styles.addressBlock}>
              <Text style={styles.addressHeader}>Delivery Address</Text>
              <Text style={styles.addressContent}>
                {transaction.customer.name}
              </Text>
              <Text style={styles.addressContent}>
                {transaction.customer.deliveryAddress.street}
              </Text>
              <Text
                style={styles.addressContent}
              >{`${transaction.customer.deliveryAddress.city}, ${transaction.customer.deliveryAddress.state} ${transaction.customer.deliveryAddress.zip}`}</Text>
              <Text style={styles.addressContent}>
                {transaction.customer.deliveryAddress.country}
              </Text>
            </View>
          )}
          {transaction.customer.billingAddress && (
            <View style={styles.addressBlock}>
              <Text style={styles.addressHeader}>Billing Address</Text>
              <Text style={styles.addressContent}>
                {transaction.customer.name}
              </Text>
              <Text style={styles.addressContent}>
                {transaction.customer.billingAddress.street}
              </Text>
              <Text
                style={styles.addressContent}
              >{`${transaction.customer.billingAddress.city}, ${transaction.customer.billingAddress.state} ${transaction.customer.billingAddress.zip}`}</Text>
              <Text style={styles.addressContent}>
                {transaction.customer.billingAddress.country}
              </Text>
            </View>
          )}
        </View>

        <View style={styles.detailsTable}>
          <View style={styles.tableHeader}>
            <Text style={[styles.tableCellHeader, { flex: 2 }]}>
              Order Reference
            </Text>
            <Text style={[styles.tableCellHeader, { flex: 2 }]}>
              Order Date
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, { flex: 2 }]}>
              {transaction.id}
            </Text>
            <Text style={[styles.tableCell, { flex: 2 }]}>
              {transaction.orderDate}
            </Text>
          </View>
        </View>

        <View style={productTableStyles.table}>
          <View style={productTableStyles.tableHeader}>
            <Text style={[productTableStyles.tableColHeader, { flex: 2 }]}>
              Product
            </Text>{' '}
            <Text style={productTableStyles.tableColHeader}>Qty</Text>
            <Text style={productTableStyles.tableColHeader}>Unit Price</Text>
            <Text style={productTableStyles.tableColHeader}>Subtotal</Text>
          </View>
          {transaction.items.map((item: any, index: number) => (
            <View style={productTableStyles.tableRow} key={`${index}`}>
              <Text style={[productTableStyles.productDescription]}>
                {item.description}
              </Text>
              <Text style={[productTableStyles.tableCol]}>{item.quantity}</Text>
              <Text style={[productTableStyles.tableCol]}>
                {/* {formatCurrency(item.unitPrice)} */}
                {transaction.upgradeOrDowngrade !== undefined &&
                transaction.upgradeOrDowngrade !== ''
                  ? formatCurrency(transaction.subtotal ?? 0)
                  : formatCurrency(item.unitPrice)}
              </Text>
              <Text style={[productTableStyles.tableCol]}>
                {formatCurrency(item.quantity * item.unitPrice)}
                {/* {formatCurrency(transaction.subtotal ?? 0)} */}
              </Text>
            </View>
          ))}
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <View style={paymentStyles.box}>
            <View style={paymentStyles.row}>
              <Text style={paymentStyles.header}>Payment Method</Text>
              <Text style={paymentStyles.content}>
                {' '}
                {transaction.paymentMethod} {formatCurrency(transaction.total)}{' '}
              </Text>
            </View>
            <View style={paymentStyles.row}>
              <Text style={paymentStyles.header}>Carrier</Text>
              <Text style={paymentStyles.content}>Electronic Delivery</Text>
            </View>
          </View>

          <View style={summaryStyles.box}>
            <View style={summaryStyles.row}>
              <Text style={summaryStyles.label}>Subtotal</Text>
              <Text style={summaryStyles.value}>
                {formatCurrency(transaction.subtotal ?? 0)}
              </Text>
            </View>
            <View style={summaryStyles.row}>
              <Text style={summaryStyles.label}>Shipping Costs</Text>
              <Text style={summaryStyles.value}>Free Shipping</Text>
            </View>
            {transaction.discountAmount && transaction.discountCode && (
              <View style={summaryStyles.row}>
                <Text style={summaryStyles.label}>
                  Discount Code {transaction.discountCode}
                </Text>
                <Text style={summaryStyles.value}>
                  {formatCurrency(transaction.discountAmount)}
                </Text>
              </View>
            )}
            <View style={summaryStyles.row}>
              <Text style={summaryStyles.label}>Total (Tax excl.)</Text>
              <Text style={summaryStyles.value}>
                {formatCurrency(transaction.total)}
              </Text>
            </View>
            <View style={summaryStyles.row}>
              <Text style={[summaryStyles.label, { fontWeight: 'bold' }]}>
                Total
              </Text>
              <Text style={[summaryStyles.value, { fontWeight: 'bold' }]}>
                {formatCurrency(transaction.total)}
              </Text>
            </View>
          </View>
        </View>

        {/* Serial keys without 'PWRP' prefix */}
        {/* {nonPowerSearchSerials.length > 0 && (
          <Text style={styles.footer}>
            Your Serial key is: {nonPowerSearchSerials.join(', ')}
          </Text>
        )} */}

        {/* Serial keys with 'PWRP' prefix */}
        {/* {powerSearchSerials.length > 0 && (
          <>
            <Text style={styles.footer}>
              Please make sure to use the PowerSearch serial number to authorize
              PowerSearch. Your subscription serial number will activate all
              other plugins but not PowerSearch.
            </Text>
            <Text style={styles.footer}>
              PowerSearch Serial key(s): {powerSearchSerials.join(', ')}
            </Text>
          </>
        )} */}

        {/* Serial keys grouped by product name, assuming same order */}
        {/* {transaction.serialKey &&
          transaction.serialKey
            .split(',')
            .map((serial: string, index: number) => {
              const product = transaction.items[index];
              if (!product) return null;

              return (
                <View key={`serial-${index}`} style={{ marginTop: 10 }}>
                  <Text style={[styles.footer, { fontWeight: 'bold' }]}>
                    {product.description} Serial Key:
                  </Text>
                  <Text style={styles.footer}>{serial}</Text>
                </View>
              );
            })} */}

        {/* Condensed product-serial output */}
        {/* {transaction.serialKey &&
          transaction.serialKey.split(',').length > 0 && (
            <Text style={styles.footer}>
              {transaction.items
                .map((item: any, index: number) => {
                  const serial = transaction.serialKey.split(',')[index];
                  if (!serial) return null;

                  return `${item.description}: ${serial}`;
                })
                .filter(Boolean)
                .join('; ')}
            </Text>
          )} */}

        {/* Condensed + grouped product serials */}
        {/* {transaction.serialKey && (
          <View style={{ marginTop: 10 }}>
            <Text style={[styles.footer, { fontWeight: 'bold' }]}>
              Your Serial Key(s):
            </Text>
            <Text style={styles.footer}>
              {(() => {
                const serials = transaction.serialKey
                  .split(',')
                  .map((s) => s.trim());
                const grouped: Record<string, string[]> = {};

                transaction.items.forEach((item: any, index: number) => {
                  const desc = item.description;
                  const serial = serials[index];
                  if (!serial) return;

                  if (!grouped[desc]) {
                    grouped[desc] = [];
                  }
                  grouped[desc].push(serial);
                });

                return Object.entries(grouped)
                  .map(([desc, keys]) => `${desc}: ${keys.join(', ')}`)
                  .join('; ');
              })()}
            </Text>
          </View>
        )} */}

        <View style={{ marginTop: 10 }}>
          <Text style={[styles.footer, { fontWeight: 'bold' }]}>
            Your Serial Key(s):
          </Text>
          <Text style={styles.footer}>
            {(() => {
              const grouped: Record<string, string[]> = {};
              const powerSearchSerialsIn: string[] = [];

              transaction.items.forEach((item: any) => {
                if (!item.serials) return;

                item.serials.forEach((serial: string) => {
                  if (serial.startsWith('PWRP')) {
                    powerSearchSerialsIn.push(serial);
                  } else {
                    if (!grouped[item.description]) {
                      grouped[item.description] = [];
                    }
                    grouped[item.description].push(serial);
                  }
                });
              });

              const lines: string[] = [];

              for (const [desc, serials] of Object.entries(grouped)) {
                lines.push(`${desc}: ${serials.join(', ')}`);
              }

              if (powerSearchSerialsIn.length > 0) {
                lines.push(`PowerSearch: ${powerSearchSerialsIn.join(', ')}`);
              }

              // return lines.join('; ');
              // return (
              //   <>
              //     {lines.map((line, idx) => (
              //       <Text key={idx} style={styles.footer}>
              //         {line}
              //       </Text>
              //     ))}
              //   </>
              // );

              return (
                <View>
                  {lines.map((line, idx) => (
                    <View key={idx} style={{ marginTop: 2 }}>
                      <Text style={[styles.bold, { fontWeight: 900 }]}>
                        {idx + 1}. {line} {'\n\n'}
                      </Text>
                    </View>
                  ))}
                </View>
              );
            })()}
          </Text>
        </View>

        {/* Serial keys with 'PWRP' prefix */}
        {powerSearchSerials.length > 0 && (
          <>
            <Text style={styles.footer}>
              Please make sure to use the PowerSearch serial number to authorize
              PowerSearch. Your subscription serial number will activate all
              other plugins but not PowerSearch.
            </Text>
            {/* <Text style={styles.footer}>
              PowerSearch Serial key(s): {powerSearchSerials.join(', ')}
            </Text> */}
          </>
        )}

        <Text style={styles.footer}>
          You can download your product at{' '}
          <Link src="https://digitalanarchy.com/demos/main.html">
            https://digitalanarchy.com/demos/main.html
          </Link>{' '}
          and use your serial number to remove the watermark. Demo downloads are
          the same as the full version of the software!
        </Text>
        <Text style={styles.footer}>
          Setup and installation video tutorials are available here:{' '}
          <Link src="https://digitalanarchy.com/support/install.html">
            https://digitalanarchy.com/support/install.html
          </Link>
        </Text>
        <Text style={styles.footer}>
          {
            "If you have any questions or concerns regarding your order, please don't hesitate to contact us at "
          }
          <Link src="mailto:sales@digitalanarchy.com">
            sales@digitalanarchy.com
          </Link>
        </Text>
        <Text style={styles.footer}>
          <Link src="https://digitalanarchy.com">Digital Anarchy</Link>
        </Text>
      </Page>
    </Document>
  );
};

export default ExportPDFView;
